import { UtensilsCrossed } from 'lucide-react';
import GenericModulePage from './GenericModulePage';
import { canteenAPI } from '../lib/api';

const config = {
  title: 'Canteen',
  subtitle: 'Menu items and meal serving records.',
  icon: UtensilsCrossed,
  permPrefix: 'canteen',
  testId: 'canteen',
  idLabel: 'Item',
  fields: [
    { key: 'item_name', label: 'Item Name', type: 'text', required: true, listColumn: true },
    { key: 'category', label: 'Category', type: 'select', options: ['Breakfast', 'Lunch', 'Dinner', 'Snacks', 'Beverage', 'Diet (Patient)'], listColumn: true },
    { key: 'is_veg', label: 'Vegetarian?', type: 'select', options: ['Yes', 'No'], listColumn: true },
    { key: 'price', label: 'Price (₹)', type: 'number', required: true, listColumn: true },
    { key: 'available_for', label: 'Available For', type: 'select', options: ['All', 'Patients Only', 'Staff Only', 'Visitors'], listColumn: true },
    { key: 'calories', label: 'Calories', type: 'number' },
    { key: 'preparation_time_min', label: 'Prep Time (min)', type: 'number' },
    { key: 'description', label: 'Description', type: 'textarea', fullWidth: true },
  ],
};

export default function CanteenPage() { return <GenericModulePage config={config} apiClient={canteenAPI} />; }
